import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'boolean',
  standalone: false
})
export class BooleanPipe implements PipeTransform {
  transform(value: boolean): any {
    return value ? 'yes' : 'no';
  }
}
